export const forceLogout = (prefixUrl) => {
  window.location = `${prefixUrl}/oAuth/logout?post_logout_redirect_uri=${document.location.origin}&state=`;
};
